import Styled from 'styled-components';

import { media } from '../../../lib/StyledComponents';

const Container = Styled.article`
  display: flex;
  flex-direction: column;
  margin-bottom: 3em;

  ${media.medium`
    display: block;
  `}
`;

Container.displayName = 'LandingContainer';

export default Container;
